var map = {
	"./Email.svg": 496,
	"./email-icon-hover.svg": 497,
	"./email-icon-hover_1.svg": 498,
	"./email-icon.svg": 499,
	"./email-icon_1.svg": 500,
	"./facebook-1.svg": 501,
	"./facebook-icon-2.svg": 502,
	"./facebook-icon-hover-2.svg": 503,
	"./facebook-icon-hover.svg": 504,
	"./twitter-1.svg": 505,
	"./twitter-icon-2.svg": 506,
	"./twitter-icon-hover-2.svg": 507,
	"./twitter-icon-hover.svg": 508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;